import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

const testimonials = [
  {
    name: '漫画爱好者小陈',
    role: '韩漫读者 · 3年',
    content: '韩国漫画网是我每天必刷的网站，更新速度真的很快，而且分类很清晰。不管是热门大作还是小众精品都能在这里找到，强烈推荐给喜欢韩漫的朋友！',
    rating: 5,
  },
  {
    name: '漫画收藏家Lily',
    role: '资深漫迷 · 5年',
    content: '用了很多漫画网站，韩国漫画网的体验是最好的。界面简洁美观，没有乱七八糟的广告，阅读体验特别流畅。漫画资源也很丰富，基本上我想看的都有。',
    rating: 5,
  },
  {
    name: '追漫达人小王',
    role: '日韩漫画博主',
    content: '作为一个漫画博主，我经常需要寻找最新的韩漫资讯。韩国漫画网的更新速度和资源质量让我非常满意，已经推荐给了我的所有粉丝。',
    rating: 5,
  },
];

export default function AboutPage() {
  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩国漫画网',
    url: 'https://www.example.com/',
    description: '韩国漫画网提供免费的漫画大全资源，专注于筛选最新热门的在线韩漫。涵盖恋爱、剧情、悬疑、动作等多种题材。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@koreancomic.example.com',
      availableLanguage: ['Chinese'],
    },
  };

  const webpageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '关于我们 - 韩国漫画网',
    description: '了解韩国漫画网的品牌故事、发展历程、用户口碑和联系方式。',
    url: 'https://www.example.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩国漫画网',
      url: 'https://www.example.com/',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageJsonLd)}</script>
      <Navbar />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>

        <section className="py-10 md:py-16 px-4 md:px-6 max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              关于韩国漫画网
            </h1>
            <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
              致力于为广大韩漫爱好者提供最优质的免费漫画阅读体验
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
            <div className="bg-background-100 rounded-lg p-6 md:p-8">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-4">
                <i className="ri-book-open-line text-xl"></i>
              </div>
              <h2 className="text-lg font-heading font-semibold text-foreground-950 mb-3">
                品牌故事
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                韩国漫画网诞生于一群韩漫爱好者的共同理想。我们发现，虽然韩漫在全球范围内越来越受欢迎，但中文读者常常面临资源分散、更新不及时、阅读体验差等问题。于是，我们决定打造一个专注韩漫的优质阅读平台。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mt-3">
                从最初的几十部漫画资源，到现在涵盖恋爱、剧情、悬疑、动作、奇幻、校园等多种题材的丰富内容库，我们始终坚持<strong>免费、高质量、及时更新</strong>的核心理念，让每一位读者都能在这里找到属于自己的精彩故事。
              </p>
            </div>

            <div className="bg-background-100 rounded-lg p-6 md:p-8">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mb-4">
                <i className="ri-star-line text-xl"></i>
              </div>
              <h2 className="text-lg font-heading font-semibold text-foreground-950 mb-3">
                我们的优势
              </h2>
              <ul className="flex flex-col gap-3">
                {[
                  { icon: 'ri-check-line', text: '完全免费：所有漫画资源均可免费在线阅读，无需任何会员费用' },
                  { icon: 'ri-check-line', text: '极速更新：与韩国最新连载保持同步，第一时间获取最新章节' },
                  { icon: 'ri-check-line', text: '内容精选：精心筛选优质韩漫，拒绝低质量内容，只推荐值得阅读的作品' },
                  { icon: 'ri-check-line', text: '分类清晰：覆盖8大漫画题材，轻松找到符合口味的作品' },
                  { icon: 'ri-check-line', text: '全平台适配：电脑、平板、手机均可流畅阅读，随时随地享受韩漫' },
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0 mt-0.5">
                      <i className={`${item.icon} text-xs`}></i>
                    </div>
                    <span className="text-sm text-foreground-600 leading-relaxed">{item.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mb-16">
            <h2 className="text-xl font-heading font-bold text-foreground-950 text-center mb-8">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {testimonials.map((t, i) => (
                <div key={i} className="bg-background-50 border border-background-200/70 rounded-lg p-6">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: t.rating }, (_, j) => (
                      <div key={j} className="w-4 h-4 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill text-xs"></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    "{t.content}"
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                      <i className="ri-user-line text-primary-500"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-background-100 rounded-lg p-6 md:p-8">
            <h2 className="text-xl font-heading font-bold text-foreground-950 mb-6">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-foreground-900 mb-1">电子邮箱</h3>
                  <p className="text-sm text-foreground-500">contact@koreancomic.example.com</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 flex-shrink-0">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-foreground-900 mb-1">微信公众号</h3>
                  <p className="text-sm text-foreground-500">韩国漫画网</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 flex-shrink-0">
                  <i className="ri-weibo-line text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-foreground-900 mb-1">新浪微博</h3>
                  <p className="text-sm text-foreground-500">@韩国漫画网官方</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}